import styled from 'styled-components/macro'

import { ImageContainer, Img } from 'components/parallax/styled'
import { mq } from 'styles/mq'

export const BookContainer = styled(ImageContainer)`
  ${mq.medium} {
    padding-inline: var(--spacing-sm);
  }
`

export const BookImg = styled(Img)`
  margin: 0 auto;
`

export const HandContainer = styled(ImageContainer)`
  ${mq.parallaxOff} {
    margin-left: min(calc(-1 * var(--spacing-sm)), calc(-50vw + 50%));
  }

  ${mq.medium} {
    padding-right: var(--spacing-sm);
  }

  ${mq.parallaxOn} {
    margin-bottom: -1em;
  }

  ${mq.large} {
    padding-right: var(--spacing-lg);
  }
`

export const HandImg = styled(Img)`
  max-width: 70%;

  ${mq.parallaxOn} {
    max-width: min(20em, 100%);
  }
`
